// One date format for the whole platform: dd/mm/yyyy.
//
// A YYYY-MM-DD string is split textually rather than pushed through `new Date`,
// because `new Date('2026-09-09')` is UTC midnight and a browser west of GMT
// renders it as the 8th. Anything else (an ISO timestamp, a Date) falls back to
// the local calendar parts.

const pad = (n) => String(n).padStart(2, '0');

export const formatDMY = (value, empty = '—') => {
  if (value === null || value === undefined || value === '') return empty;
  const ymd = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (ymd) return `${ymd[3]}/${ymd[2]}/${ymd[1]}`;
  const dt = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(dt.getTime())) return empty;
  return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()}`;
};

// dd/mm/yyyy HH:mm — the same date, with a 24-hour clock behind it.
export const formatDMYTime = (value, empty = '—') => {
  if (value === null || value === undefined || value === '') return empty;
  const dt = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(dt.getTime())) return empty;
  return `${formatDMY(dt, empty)} ${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
};

export default formatDMY;
